/* KIS verlanglijst (agent E, 2026-10-12). Zelfde werking als de live Minimog-verlanglijst (assets/wishlist.js):
   producthandles in localStorage, teller in de header, hartjes op de productpagina.
   Sleutel: kis:wishlist (een bestaande live lijst onder m-wishlist-products wordt eenmalig overgenomen).
   API: window.KISWishlist { add(handle), remove(handle), toggle(handle), has(handle), list() }.
   Knoppen: [data-kis-wishlist-toggle][data-handle] krijgen .is-active + aria-pressed; tellers: [data-kis-wishlist-count].
   Gebeurtenis: document 'kis:wishlist:change' met detail { handles }. */
(function () {
  if (window.KISWishlist) return;
  var KEY = 'kis:wishlist';
  var OLD_KEY = 'm-wishlist-products';
  var handles = [];

  function read() {
    var raw = null;
    try {
      raw = window.localStorage.getItem(KEY);
      if (raw === null) raw = window.localStorage.getItem(OLD_KEY);
    } catch (e) {
      raw = null;
    }
    var list = [];
    try {
      list = JSON.parse(raw) || [];
    } catch (e) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];
    var seen = {};
    return list.filter(function (h) {
      h = String(h || '').trim();
      if (!h || seen[h]) return false;
      seen[h] = true;
      return true;
    });
  }

  function save() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function has(handle) {
    return handles.indexOf(String(handle)) !== -1;
  }

  function render() {
    var n = handles.length;
    var counts = document.querySelectorAll('[data-kis-wishlist-count]');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = n;
      if (n > 0) counts[i].removeAttribute('hidden');
      else counts[i].setAttribute('hidden', '');
    }
    var buttons = document.querySelectorAll('[data-kis-wishlist-toggle]');
    for (var j = 0; j < buttons.length; j++) {
      var btn = buttons[j];
      var active = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var tip = btn.querySelector('[data-kis-wishlist-tip]');
      var label = active ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) {
        btn.setAttribute('aria-label', label);
        if (tip) tip.textContent = label;
      }
    }
    document.body.classList.toggle('kis-wishlist-has-items', n > 0);
  }

  function notify() {
    render();
    try {
      document.dispatchEvent(new CustomEvent('kis:wishlist:change', { detail: { handles: handles.slice() } }));
    } catch (e) {}
  }

  function add(handle) {
    handle = String(handle || '').trim();
    if (!handle || has(handle)) return false;
    handles.push(handle);
    save();
    notify();
    return true;
  }

  function remove(handle) {
    handle = String(handle || '').trim();
    if (!has(handle)) return false;
    handles = handles.filter(function (h) { return h !== handle; });
    save();
    notify();
    return true;
  }

  function toggle(handle) {
    return has(handle) ? (remove(handle), false) : (add(handle), true);
  }

  function list() {
    return handles.slice();
  }

  handles = read();
  save();

  window.KISWishlist = { add: add, remove: remove, toggle: toggle, has: has, list: list, refresh: render };

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-kis-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    toggle(btn.getAttribute('data-handle'));
  });

  /* Andere tabbladen bijhouden */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) {
      handles = read();
      notify();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
  /* Secties die later geladen worden (thema-editor, section rendering) */
  document.addEventListener('shopify:section:load', render);
  try {
    document.dispatchEvent(new CustomEvent('kis:wishlist:ready'));
  } catch (e) {}
})();
